import { useLingui } from "@lingui/react/macro";
import { locationApi } from "@/lib/api/services/location.api";
import type { Location } from "@/types/location";
import { EntitySelect } from "./EntitySelect";

export interface LocationSelectProps {
  value: number | null | undefined;
  onChange: (value: number, location: Location) => void;
  onClear?: () => void;
  companyId?: number;
  regionId?: number;
  isActive?: boolean;
  displayValue?: string;
  placeholder?: string;
  disabled?: boolean;
  triggerClassName?: string;
}

export function LocationSelect({
  value,
  onChange,
  onClear,
  companyId,
  regionId,
  isActive,
  displayValue,
  placeholder,
  disabled,
  triggerClassName,
}: LocationSelectProps) {
  const { t } = useLingui();
  return (
    <EntitySelect<Location>
      queryKeyBase={["entity-select", "locations", companyId ?? null, regionId ?? null, isActive ?? null]}
      fetchPage={({ page, limit, search }) =>
        locationApi.paginate({ page, limit, search: search || undefined, companyId, regionId, isActive })
      }
      getOptionValue={(l) => String(l.id)}
      getOptionLabel={(l) => l.name}
      fetchItem={(id) => locationApi.getById(id)}
      value={value == null ? "" : String(value)}
      onChange={(val, location) => onChange(Number(val), location)}
      onClear={onClear}
      displayValue={displayValue}
      placeholder={placeholder ?? t`Select a location...`}
      searchPlaceholder={t`Search locations…`}
      emptyMessage={t`No locations found`}
      disabled={disabled}
      triggerClassName={triggerClassName}
    />
  );
}
